var v1="<section> <h3 ng-if=\"vm.settings.displayName && vm.settings.showTitle\">{{ vm.settings.displayName }}</h3> <div ng-repeat=\"item in vm.settings.children track by $index\" class=\"{{item.formClass}}\"> <div lba-dynamic=\"'lba-' + item.displayAs\" settings=\"item\"></div> </div> </section>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaGroup.html", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbaGroup/lbaGroup.html
// module id = 176
// module chunks = 0